if (typeof window.ciudadesScriptLoaded === 'undefined') {

    window.ciudadesScriptLoaded = true;

    const texto = document.querySelector(".x_ciudad");
    const ciudades = [
        "Madrid", "Barcelona", "Valencia", "Sevilla", "Zaragoza",
        "Málaga", "Murcia", "Bilbao", "Alicante", "Córdoba", "Granada", 
        "Castellón", "Las Palmas", "Asturias"
    ];
    let ciudadActual = "";

    function getCiudadAleatoria() {
        let ciudadesFiltradas = ciudades.filter(c => c !== ciudadActual);
        return ciudadesFiltradas[Math.floor(Math.random() * ciudadesFiltradas.length)];
    }

    function Ciudades() {
        if (texto) {
            ciudadActual = getCiudadAleatoria();
            texto.innerHTML = ciudadActual;
        }
    }

    (function actualizarCiudades() {
        Ciudades();
        setTimeout(actualizarCiudades, 40000);
    })();

}